<template>
  <div>
    <validation-provider rules="required" slim v-slot="state">
      <modal-dialog :closeable="$t('common.close')" :open.sync="isSwdeInfoModalOpen" :size="'medium'">
        <p v-html="$t('new-connection-cmh.offering-selection-step.swde-info')"></p>
      </modal-dialog>

      <div class="lib__field">
        <div class="lib__tiles">
          <tile v-if="isElectricityAvailable" @validate="state.validate(selectorSelections)"
            :label="$t('new-connection-cmh.offering-selection-step.electricity')"
            :annexe="$t('new-connection-cmh.offering-selection-step.priceToBeEstimated')" smallText="&nbsp;"
            inlineContent group="energy" :item="OfferingSelectionOperator.electricity" v-model="selectorSelections">
            <template v-slot:picture>
              <img :src="require('@ores/css-library/assets/img/icons/electricity.svg')" alt="">
            </template>
          </tile>

          <tile v-if="isGasAvailable && !isGasManagerResa" @validate="state.validate(selectorSelections)"
            :label="$t('new-connection-cmh.offering-selection-step.gas')"
            :annexe="$t('new-connection-cmh.offering-selection-step.free')"
            :smallText="$t('new-connection-cmh.offering-selection-step.freeStandartConnection')" inlineContent
            group="energy" :item="OfferingSelectionOperator.gas" v-model="selectorSelections">
            <template v-slot:picture>
              <img :src="require('@ores/css-library/assets/img/icons/gas.svg')" alt="">
            </template>
          </tile>
        </div>
        <error-message :error="state.errors[0]"></error-message>
      </div>

      <feedback v-if="!isSynergyAvailable && isCmhAvailable && isConnectMyHomeAvailableForSelectedBuilding" icon simple
        level="alert">
        <h3 v-if="!isGasManagerResa">
          {{ $t('new-connection-cmh.offering-selection-step.IfYouWantToUseConnectMyHomeChooseElectricityOrGas') }}
        </h3>
        <h3 v-else>
          {{ $t('new-connection-cmh.offering-selection-step.IfYouWantToUseConnectMyHomeChooseOresElectricity') }}
        </h3>
      </feedback>

      <div class="lib__field">
        <div class="lib__tiles lib__tiles--operator">
          <tile v-if="isGasAvailable && isGasManagerResa && isConnectMyHomeAvailableForSelectedBuilding" 
            @validate="state.validate(selectorSelections)"
            :disabled="!isSynergyAvailable" :label="$t('new-connection-cmh.offering-selection-step.gas')"
            :annexe="$t('new-connection-cmh.offering-selection-step.free')"
            :smallText="$t('new-connection-cmh.offering-selection-step.freeStandartConnection')" inlineContent
            group="energy" :item="OfferingSelectionOperator.resa" v-model="selectorSelections">
            <template v-slot:picture>
              <img :src="require('@/assets/Resa.svg')" alt="">
            </template>
          </tile>
        </div>
      </div>

      <div class="lib__field">
        <div class="lib__tiles lib__tiles--operator">

          <tile v-if="isConnectMyHomeAvailableForSelectedBuilding && isSwdeAvailable" :disabled="!isSynergyAvailable"
            :label="$t('new-connection-cmh.offering-selection-step.water')"
            :annexe="$t('new-connection-cmh.offering-selection-step.priceToBeEstimated')" inlineContent
            group="offerings" :item="OfferingSelectionOperator.swde" v-model="selectorSelections">
            <template v-slot:picture>
              <img :src="require('@/assets/swde-logo-2x.png')" alt="">
            </template>
            <template v-slot:smallText>
              {{ $t('new-connection-cmh.offering-selection-step.standartWaterConnectionPrice') }}
              <sup class="lib__tooltips lib__tooltips--top-right" @click="openSwdeInfoModal()">
                <span class="lib__tooltips__trigger">
                  <i class="fas fa-info"></i>
                </span>
              </sup>
            </template>
          </tile>
        </div>
      </div>

      <div class="lib__field">
        <div class="lib__tiles lib__tiles--operator">
          <tile @click="onOfferingClick(OfferingSelectionOperator.tvPhoneInternet)"
            v-if="isConnectMyHomeAvailableForSelectedBuilding && (isProximusAvailable || isOrangeAvailable)"
            :disabled="!isSynergyAvailable" :label="$t('new-connection-cmh.offering-selection-step.tvPhoneInternet')"
            :annexe="$t('new-connection-cmh.offering-selection-step.free')"
            :smallText="$t('new-connection-cmh.offering-selection-step.freeStandartConnectionWithCmh')" inlineContent @
            group="offerings" :item="OfferingSelectionOperator.tvPhoneInternet" v-model="selectorSelections">
            <template v-slot:picture>
              <img v-if="isOrangeAvailable && isProximusAvailable" :src="require('@/assets/proximus-orange.svg')"
                alt="">
              <img v-else-if="isOrangeAvailable" :src="require('@/assets/Orange.svg')" alt="">
              <img v-else :src="require('@/assets/Proximus.svg')" alt="">
            </template>
          </tile>
        </div>
      </div>

      <div v-if="isTvPhoneInternetSelected && isConnectMyHomeAvailableForSelectedBuilding">
        <div class="lib__field">
          <div class="lib__field__group">
            <div v-if="isProximusAvailable && isOrangeAvailable" class="lib__field lib__field--radio"
              :class="{ 'lib__field--disabled': !isSynergyAvailable }">
              <input class="lib__field__input" type="radio" name="isTvPhoneInternetSelected"
                :id="OfferingSelectionOperator.proximusAndOrange"
                :checked="selectorSelections.includes(OfferingSelectionOperator.proximusAndOrange)">
              <label @click="onOfferingClick(OfferingSelectionOperator.proximusAndOrange)" class="lib__field__label"
                for="proximusAndOrange">{{
                  $t('new-connection-cmh.offering-selection-step.proximusAndOrange') }}</label>
            </div>
            <div v-if="isOrangeAvailable" class="lib__field lib__field--radio"
              :class="{ 'lib__field--disabled': !isSynergyAvailable }">
              <input class="lib__field__input" type="radio" name="isTvPhoneInternetSelected"
                :id="OfferingSelectionOperator.orange"
                :checked="selectorSelections.includes(OfferingSelectionOperator.orange)">
              <label @click="onOfferingClick(OfferingSelectionOperator.orange)" class="lib__field__label"
                for="orange">{{
                  $t('new-connection-cmh.offering-selection-step.orange') }}</label>
            </div>
            <div v-if="isProximusAvailable" class="lib__field lib__field--radio"
              :class="{ 'lib__field--disabled': !isSynergyAvailable }">
              <input class="lib__field__input" type="radio" name="isTvPhoneInternetSelected"
                :id="OfferingSelectionOperator.proximus"
                :checked="selectorSelections.includes(OfferingSelectionOperator.proximus)">
              <label @click="onOfferingClick(OfferingSelectionOperator.proximus)" class="lib__field__label"
                for="proximus">{{
                  $t('new-connection-cmh.offering-selection-step.proximus') }}</label>
            </div>
          </div>
        </div>
        <feedback v-if="isSynergyAvailable && isCmhAvailable" icon simple level="alert">
          <h3 v-if="!isOnlyProximusAvailable">{{ $t('new-connection-cmh.offering-selection-step.chooseOrangeOrProximus')
            }}
          </h3>
          <h3 v-else>{{ $t('new-connection-cmh.offering-selection-step.chooseMobileVikingsOrScarlet') }}</h3>
        </feedback>

      </div>

    </validation-provider>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { helper } from '@/services'
import MoreInformation from '@/components/display/MoreInformation.vue'
import { OfferingSelectionOperator } from '@/models';
import { Getter, Mutation, State } from 'vuex-class';
import { MutationType } from '@/store/new-connection-cmh/offerings-selection/mutations';
import { hasAnyOperator } from '@/store/new-connection-cmh/offerings-selection/getters';

type OfferingTvInternetPhoneOperator = OfferingSelectionOperator.proximus | OfferingSelectionOperator.orange | OfferingSelectionOperator.proximusAndOrange

@Component({
  components: {
    MoreInformation,
  },
  name: 'cmh-offerings-selector'
})
export default class CmhOfferingsSelector extends Vue {
  @Prop({ type: Boolean, required: true }) public isCmhAvailable!: boolean

  // Declare enum for template
  OfferingSelectionOperator = OfferingSelectionOperator;
  public isSwdeInfoModalOpen: boolean = false
  private selectorSelections: OfferingSelectionOperator[] = []

  @Mutation(MutationType.MUTATION_STORE, { namespace: 'newConnectionCmh/offeringsSelection' })
  private store!: (payload: OfferingSelectionOperator[]) => void

  @State('selections', { namespace: 'newConnectionCmh/offeringsSelection' })
  private stateSelections!: OfferingSelectionOperator[]

  @Getter('isElectricitySelected', { namespace: 'newConnectionCmh/offeringsSelection' })
  private isElectricitySelected!: boolean
  @Getter('isGasSelected', { namespace: 'newConnectionCmh/offeringsSelection' })
  private isGasSelected!: boolean
  @Getter('isSynergyAvailable', { namespace: 'newConnectionCmh/offeringsSelection' })
  private isSynergyAvailable!: boolean
  @Getter('isElectrictyOrGasSelected', { namespace: 'newConnectionCmh/offeringsSelection' })
  private isElectrictyOrGasSelected!: boolean
  @Getter('isElectricityAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  private isElectricityAvailable!: boolean
  @Getter('isGasAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  private isGasAvailable!: boolean
  @Getter('isGasManagerResa', { namespace: 'newConnectionCmh/cmhAddress' })
  private isGasManagerResa!: boolean
  @Getter('isConnectMyHomeAvailableForSelectedBuilding', { namespace: 'newConnectionCmh/cmhAddress' })
  private isConnectMyHomeAvailableForSelectedBuilding!: boolean
  @Getter('isProximusAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  private isProximusAvailable!: boolean
  @Getter('isOnlyProximusAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  private isOnlyProximusAvailable!: boolean
  @Getter('isProximusAndOrangeAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  private isProximusAndOrangeAvailable!: boolean


  @Getter('isOrangeAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  public isOrangeAvailable!: boolean
  @Getter('isSwdeAvailable', { namespace: 'newConnectionCmh/cmhAddress' })
  public isSwdeAvailable!: boolean

  private mounted() {
    this.selectorSelections = helper.clone(this.stateSelections)
  }

  /**
   * Whether an operator should be added to the offerings.
   * This is determined by its presence in the selections array.
   * @param operator The operator.
   * @returns Whether to add the operator or not.
   */
  private shouldAddOperator(operator: OfferingSelectionOperator): boolean {
    return !hasAnyOperator(this.selectorSelections, operator)
  }

  private handleOperator(operator: OfferingSelectionOperator, shouldAddOperator: boolean) {
    if (shouldAddOperator) {
      this.addOperator(operator)
      return;
    }

    this.removeOperator(operator)
  }

  private addOperator(operator: OfferingSelectionOperator) {
    if (this.selectorSelections.find(s => s !== operator)) {
      this.selectorSelections = [...this.selectorSelections, operator]
    }
  }

  private removeOperator(operator: OfferingSelectionOperator) {
    this.selectorSelections = this.selectorSelections.filter(s => s !== operator)
  }

  private removeManyOperators(...operators: OfferingSelectionOperator[]) {
    this.selectorSelections = this.selectorSelections.filter(s => !operators.includes(s))
  }

  private handleTvInternetPhone(shouldAddOperator: boolean) {
    if (!shouldAddOperator) {
      this.removeManyOperators(
        OfferingSelectionOperator.proximusAndOrange,
        OfferingSelectionOperator.proximus,
        OfferingSelectionOperator.orange
      )
      return;
    }

    if (this.isProximusAndOrangeAvailable) {
      this.addOperator(OfferingSelectionOperator.proximusAndOrange)
      return;
    }

    if (this.isOnlyProximusAvailable) {
      this.addOperator(OfferingSelectionOperator.proximus)
      return;
    }

    this.addOperator(OfferingSelectionOperator.orange)
  }

  private handleTvInternetPhoneOperator(operator: OfferingTvInternetPhoneOperator, shouldAddOperator: boolean) {
    if (!shouldAddOperator) {
      return;
    }

    this.addOperator(operator)
    // If an operator has been added, the others must be removed. 
    switch (operator) {
      case OfferingSelectionOperator.proximusAndOrange:
        this.removeManyOperators(OfferingSelectionOperator.proximus, OfferingSelectionOperator.orange)
        break;
      case OfferingSelectionOperator.proximus:
        this.removeManyOperators(OfferingSelectionOperator.proximusAndOrange, OfferingSelectionOperator.orange)
        break;
      case OfferingSelectionOperator.orange:
        this.removeManyOperators(OfferingSelectionOperator.proximusAndOrange, OfferingSelectionOperator.proximus)
        break;
      default:
        throw TypeError('An operator with this type does not exist.')
    }
  }

  public get isTvPhoneInternetSelected() {
    return hasAnyOperator(this.selectorSelections, OfferingSelectionOperator.tvPhoneInternet)
  }

  public get isOneOtherOfferingSelected() {
    return hasAnyOperator(this.selectorSelections, OfferingSelectionOperator.resa, OfferingSelectionOperator.swde, OfferingSelectionOperator.tvPhoneInternet)
  }

  public openSwdeInfoModal() {
    this.isSwdeInfoModalOpen = true
  }

  private onOfferingClick(operator: OfferingSelectionOperator) {
    const toAdd = this.shouldAddOperator(operator)

    switch (operator) {
      case OfferingSelectionOperator.tvPhoneInternet:
        this.handleTvInternetPhone(toAdd)
        break;
      case OfferingSelectionOperator.proximusAndOrange:
      case OfferingSelectionOperator.proximus:
      case OfferingSelectionOperator.orange:
        this.handleTvInternetPhoneOperator(operator, toAdd)
        break;
      default:
        // Every other case are already handled by v-model in child components
        break;
    }
  }

  @Watch('selectorSelections')
  public onSelectionsChange() {
    if (!this.isSynergyAvailable && this.isOneOtherOfferingSelected) {
      this.selectorSelections = []
    }

    this.store(this.selectorSelections)
  }
}


</script>

<style>
.lib__tiles--operator .lib__tile--content-inline .lib__tile__picture {
  width: 76px;
  height: 50px;
}
</style>
